<template>
  <div class="login-main">
    <img
      class="posImg logo"
      @click="goUrl('/')"
      src="@/assets/image/common/logo-bule.png"
    />
    <img class="posImg top" src="@/assets/image/login/top.png" />
    <img class="posImg bottom" src="@/assets/image/login/bottom.png" />
    <div class="content">
      <div class="img-box">
        <img src="@/assets/image/login/img-icon.png" />
        <div class="text-box">
          <span class="share">{{ $t("login.titleBox.title1") }}</span>
          <span>{{ $t("login.titleBox.title2") }}</span>
        </div>
      </div>
      <div class="content-box">
        <div class="herder">
          <div :class="[{ active: type === 1 }]" @click="type = 1">
            {{ $t("login.titleBox.title4") }}
          </div>
        </div>
        <div class="from-box">
          <div class="title">{{ $t("login.titleBox.title5") }}</div>
          <input v-model="phone" :placeholder="$t('login.titleBox.title7')" />
        </div>
    
        <div class="from-box" v-if="type === 1">
          <div class="title">{{ $t("login.titleBox.title16") }}</div>

          <div class="password-box">
            <input
              v-model="password"
              :placeholder="$t('login.titleBox.title17')"
              :type="passwordType"
            />
            <img
              class="eyes"
              v-if="passwordType === 'password'"
              @click="passwordType = 'text'"
              src="@/assets/image/login/close-eyes.png"
            />
            <img
              class="eyes"
              v-if="passwordType === 'text'"
              @click="passwordType = 'password'"
              src="@/assets/image/login/open-eyes.png"
            />
          </div>
        </div>
        <div class="flot" @click="goUrl('/forgotPassword')" v-if="type === 1">
          {{ $t("login.titleBox.title9") }}
        </div>
        <div
          :class="`sunmit ${flag ? 'sunmit-active' : ''}`"
          @click="sunmit('/module')"
        >
          {{ $t("login.titleBox.title10") }}
        </div>
        <div class="checkbox-fa">
          <div class="text">
            {{ $t("login.titleBox.title11")
            }}<span @click="goUrl(`/module/help?id=1`)"
              >【{{ $t("login.titleBox.title12") }}】</span
            >和<span @click="goUrl(`/module/help?id=2`)"
              >【{{ $t("login.titleBox.title13") }}】</span
            >
          </div>
        </div>
        <div class="footer">
          <div class="left" @click="goUrl('/register')">
            {{ $t("login.titleBox.title14") }}
          </div>
          <div class="right">
            <span>{{ $t("login.titleBox.title15") }}</span>
            <img src="@/assets/image/login/weixin.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { setLogin, getAccount } from "@/api/user";
export default {
  data() {
    return {
      type: 1,
      checked: false,
      phone: null,
      password: null,
      passwordType: "password",
      flag: false,
    };
  },
  methods: {
    goUrl(path) {
      this.$router.push(path);
    },
    sunmit(path) {
      if (this.flag) {
        return;
      }
      this.flag = true;
      localStorage.setItem("login", true);
      setLogin({
        phone: this.phone,
        password: this.password,
      }).then((res) => {
        this.flag = false;
        if (res.code === 200) {
          localStorage.setItem("token", res.data.token);
          getAccount().then((res) => {
            if (res.code === 200) {
              localStorage.setItem("userInfo", JSON.stringify(res.data));
              this.$router.push(path);
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.login-main {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  position: relative;
  .posImg {
    position: absolute;
    z-index: 1;
  }
  .logo {
    width: 156px;
    height: 52.5px;
    top: 46px;
    left: 147px;
    cursor: pointer;
  }
  .top {
    width: 246px;
    height: 226px;
    top: 0;
    right: 0;
  }
  .bottom {
    width: 246px;
    height: 229px;
    bottom: 0;
    left: 0;
  }
  .content {
    width: 1032px;
    height: 550px;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    display: flex;
    box-shadow: 0px 0px 30px 1px rgba(0, 0, 0, 0.05);
    border-radius: 10px 10px 10px 10px;
    .img-box {
      flex-shrink: 0;
      width: 50%;
      background: #f3edfd;
      img {
        width: 425px;
        height: 380px;
        margin-top: 70px;
        margin-left: 46px;
      }
      .text-box {
        display: flex;
        font-size: 22px;
        justify-content: center;
        margin-top: 28px;
        .share {
          margin-right: 42px;
          color: #8948ff;
        }
      }
    }
    .content-box {
      width: 50%;
      .herder {
        display: flex;
        color: #232323;
        font-size: 20px;
        font-weight: bolder;
        margin-top: 39px;
        justify-content: space-between;
        width: 370px;
        margin-left: 67px;
        div {
          cursor: pointer;
        }
        .active {
          color: #8948ff;
        }
      }
      .from-box {
        width: 370px;
        margin-left: 67px;
        .title {
          margin-top: 32px;
          font-size: 14px;
          color: #232323;
          margin-bottom: 13px;
        }
        .code-box {
          display: flex;
          justify-content: space-between;
          input {
            width: 220px;
            flex-shrink: 0;
          }
          img {
            flex-shrink: 0;
            width: 130px;
            height: 48px;
          }
        }
        .password-box {
          position: relative;
          input {
            padding-right: 50px;
            box-sizing: border-box;
          }
          .eyes {
            position: absolute;
            width: 30px;
            height: 30px;
            cursor: pointer;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        input {
          border: none;
          outline: none;
          background-color: #fafafa;
          width: 100%;
          height: 48px;
          font-size: 14px;
          padding: 0 24px;
          box-sizing: border-box;
        }
        input::placeholder {
          color: #999;
          opacity: 1;
        }
      }
      .flot {
        float: left;
        margin-left: 67px;
        margin-top: 19px;
        color: #6556fa;
        font-size: 14px;
        cursor: pointer;
      }
      .sunmit {
        display: block;
        border: none;
        padding: 0;
        width: 370px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #8846ff;
        border-radius: 4px 4px 4px 4px;
        margin-left: 67px;
        margin-top: 50px;
        cursor: pointer;
        color: #fff;
      }
      .sunmit-active {
        cursor: no-drop;
        opacity: 0.7;
      }
      .checkbox-fa {
        width: 370px;
        margin-left: 67px;
        display: flex;
        margin-top: 40px;
        align-items: center;
        .text {
          font-size: 14px;
          color: #232323;
          margin-left: 3px;
          span {
            color: #8948ff;
            cursor: pointer;
          }
        }
      }
      .footer {
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 370px;
        margin-left: 67px;
        margin-top: 30px;
        .left {
          color: #8948ff;
          cursor: pointer;
        }
        .right {
          display: flex;
          color: #232323;
          align-items: center;
          img {
            width: 30px;
            height: 30px;
            margin-left: 21px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1100px) {
  .login-main {
    .content {
      width: 516px;
      .img-box {
        display: none;
      }
      .content-box {
        width: 100%;
      }
    }
  }
}
/* 媒体查询 */
@media only screen and (max-width: 750px) {
  .login-main {
    background-color: #f7f8fa;
    .logo {
      width: 104px;
      height: 35px;
      top: 15px;
      left: 15px;
    }
    .top {
      display: none;
    }
    .bottom {
      display: none;
    }
    .content {
      width: calc(100% - 30px);
      margin-left: 15px;
      left: 0;
      transform: translateY(-50%);
      padding: 15px;
      box-sizing: border-box;
      .img-box {
        display: none;
      }
      .content-box {
        width: 100%;
        .herder {
          display: flex;
          color: #232323;
          font-size: 20px;
          font-weight: bolder;
          margin-top: 39px;
          justify-content: space-between;
          width: 100%;
          margin-left: 0;
          div {
            cursor: pointer;
          }
          .active {
            color: #8948ff;
          }
        }
        .from-box {
          width: 100%;
          margin-left: 0;
          .title {
            margin-top: 32px;
            font-size: 14px;
            color: #232323;
            margin-bottom: 13px;
          }
          .code-box {
            display: flex;
            justify-content: space-between;
            input {
              width: 220px;
              flex-shrink: 0;
            }
            img {
              flex-shrink: 0;
              width: 130px;
              height: 48px;
            }
          }
          input {
            border: none;
            outline: none;
            background-color: #fafafa;
            width: 100%;
            height: 48px;
            font-size: 14px;
            padding: 0 24px;
            box-sizing: border-box;
          }
          input::placeholder {
            color: #999;
            opacity: 1;
          }
        }
        .flot {
          float: left;
          margin-left: 0;
          margin-top: 19px;
          color: #6556fa;
          font-size: 14px;
          cursor: pointer;
        }
        .sunmit {
          display: block;
          border: none;
          padding: 0;
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #8846ff;
          border-radius: 4px 4px 4px 4px;
          margin-left: 0;
          margin-top: 50px;
          cursor: pointer;
          color: #fff;
        }
        .checkbox-fa {
          width: 100%;
          margin-left: 0;
          display: flex;
          margin-top: 40px;
          align-items: center;
          .text {
            font-size: 14px;
            color: #232323;
            margin-left: 3px;
            span {
              color: #8948ff;
            }
          }
        }
        .footer {
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          margin-left: 0;
          margin-top: 30px;
          .left {
            color: #8948ff;
          }
          .right {
            display: flex;
            color: #232323;
            align-items: center;
            img {
              width: 30px;
              height: 30px;
              margin-left: 21px;
            }
          }
        }
      }
    }
  }
}
</style>